import { render } from "./ToolbarButton.vue?vue&type=template&id=26f287a8"
import script from "./ToolbarButton.vue?vue&type=script&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ToolbarButton.vue"]])

export default __exports__